<template>
  <div class="flex items-center justify-between text-white">
    <div class="flex items-center gap-1.5">
      <img
        v-if="img"
        :src="img"
        alt=""
        class="h-6 w-auto rounded-full"
      />
      <h1 class="text-sm font-medium">{{ title }}</h1>
    </div>
    <p
      class="bg-gray-5 rounded border border-block-2 py-0.5 px-2 flex items-center justify-center text-center text-sm gap-1.5"
      :class="{
        'text-success': success,
        'text-danger': danger,
      }"
    >
      <img
        v-if="imgValue"
        :src="imgValue"
        alt=""
        class="h-6 w-auto rounded-full"
      />
      <span>{{ value }}</span>
    </p>
  </div>
</template>

<script>
export default {
  name: "TextInfo",
  props: {
    img: {
      type: String,
    },
    imgValue: {
      type: String,
    },
    title: {
      type: String,
    },
    value: {
      type: String,
    },
    success: {
      type: Boolean,
    },
    danger: {
      type: Boolean,
    },
  },
};
</script>
